/** HQ admin scope from login / JWT (organization = HQ Operations, regions = regional). */

export function normalizeAdminScope(raw) {
  return String(raw || "").trim().toLowerCase() === "organization" ? "organization" : "regions";
}

export function readAdminScope(storagePrefix = "naturals_workspace") {
  const fromStore = localStorage.getItem(`${storagePrefix}_admin_scope`);
  if (fromStore) return normalizeAdminScope(fromStore);
  return "regions";
}

export function persistAdminScope(scope, storagePrefix = "naturals_workspace") {
  localStorage.setItem(`${storagePrefix}_admin_scope`, normalizeAdminScope(scope));
}

export function isOrganizationAdminScope(storagePrefix = "naturals_workspace") {
  return readAdminScope(storagePrefix) === "organization";
}
